import React, { useContext, useMemo } from 'react'
import { BlockAction, BlockActionContext, useBlockMetadata } from '../../components/blocks/BlockState';
import { dashboardIdSelector, useStateSelector } from '../../data/global/dataSelectors';
import { useDispatcher } from '../../data/global/hooks';
import { blockSettings } from '../../data/global/selectors/settingSelectors';
import { BlockDragHandle } from '@tradingblock/components';

interface AccountHeaderProps {
    showRefresh: boolean
}
export const AccountHeader = ({ showRefresh }: AccountHeaderProps) => {

    const dispatch = useContext(BlockActionContext);
    const { dispatcher } = useDispatcher();
    const dashboardId = useStateSelector(dashboardIdSelector);
    const { blockId, type } = useBlockMetadata();
    const blockType = type;
    //@ts-ignore
    const settings = useStateSelector(s => blockSettings.account(s, blockId));

    useMemo(() => {
        const settingsSaveData = {
            dashboardId: dashboardId || '',
            blockId,
            blockType,
            blockSettings: {
                ...settings,
                showRefresh: showRefresh
            },
        };
        dispatch(BlockAction.setSettings(settingsSaveData.blockSettings));
        dispatcher.settings.block.setBlockSetting(settingsSaveData);

    }, [showRefresh])

    return (<BlockDragHandle>Balances</BlockDragHandle>)
}

export default AccountHeader
